import {
  type DashboardActions,
  InternalDashboardActions,
} from '@store/reducers/dashboard/actions'
import { call, put } from 'redux-saga/effects'

import API from '@/api'

export function* removeAvatar({
  payload,
}: ReturnType<typeof DashboardActions.teams.removeAvatar>) {
  const { workspaceId } = payload
  yield put(
    InternalDashboardActions.update({ workspaceId, data: { avatar: null } })
  )
  yield call(API.Team.deleteAvatar, workspaceId)
}
